import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { useDispatch, useSelector } from 'react-redux';
import { Helmet } from 'react-helmet-async';
import { PAGES } from '../../constants/pages';
import {
  APPLICATION_TYPE_INDIVIDUAL,
  APPLICATION_TYPE_IRA,
  APPLICATION_TYPE_UTMA,
} from '../../constants/accountTypes';

import SelectList from '../../components/SelectList/SelectList';
import BaseLayout from '../../components/BaseLayout';
import { Heading, HeadingParagraph } from '../../components/Heading';
import { applicationTypeSetupSuccess } from '../../store/actions/application/applicationActions';
import Paragraph from '../../components/Paragraph/Paragraph';
import themeColors from '../../assets/styles/themeColors';
import { selectSettings } from '../../store/selectors/settingsSelectors';

const CreateApplication = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { BrokerName } = useSelector(selectSettings);

  const standardAccountOptions = [
    {
      title: t('selectPath.options.standard.title'),
      subtitle: t('selectPath.options.standard.subtitle'),
      onClick: () => {
        dispatch(
          applicationTypeSetupSuccess({
            ApplicationType: APPLICATION_TYPE_INDIVIDUAL,
          }),
        );

        history.push(PAGES.CREATE_APPLICATION.STANDARD.MAIN);
      },
      showDivider: false,
    },
  ];

  const taxAdvantagedAccountOptions = [
    {
      title: t('selectPath.options.retirement.title'),
      subtitle: t('selectPath.options.retirement.subtitle'),
      onClick: () => {
        dispatch(
          applicationTypeSetupSuccess({
            ApplicationType: APPLICATION_TYPE_IRA,
          }),
        );

        history.push(PAGES.CREATE_APPLICATION.RETIREMENT.MAIN);
      },
      showDivider: false,
    },
    {
      title: t('selectPath.options.gift.title'),
      subtitle: t('selectPath.options.gift.subtitle'),
      onClick: () => {
        dispatch(
          applicationTypeSetupSuccess({
            ApplicationType: APPLICATION_TYPE_UTMA,
          }),
        );

        history.push(PAGES.CREATE_APPLICATION.UTMA.MAIN);
      },
      showDivider: false,
    },
  ];

  return (
    <BaseLayout previousPath={PAGES.BASE}>
      <Helmet>
        <title>
          {t('selectPath.titleTag', {
            brokerName: BrokerName,
          })}
        </title>
      </Helmet>
      <Heading mb={28} fontWeight={700}>
        {t('selectPath.openNewAccount.title')}
      </Heading>
      <HeadingParagraph color={themeColors.colorTextSecondary}>
        {t('selectPath.standardAccount')}
      </HeadingParagraph>

      <Paragraph>
        {t('selectPath.openNewAccount.openAVerifiedAccount')}
      </Paragraph>

      <SelectList options={standardAccountOptions} isChooseApp />
      <HeadingParagraph mt={30} color={themeColors.colorTextSecondary}>
        {t('selectPath.taxAdvantagedAccount')}
      </HeadingParagraph>
      <Paragraph>{t('selectPath.openAnAccountForRetirement')}</Paragraph>

      <SelectList options={taxAdvantagedAccountOptions} isChooseApp />
    </BaseLayout>
  );
};

export default CreateApplication;
